<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Cathy O Malley was born in the West of Ireland and grew up listening to the music of Motown, Rock and Roll and seventies music.</p><br/>
<p style="text-indent: 00em;">The author travelled to the Middle East with her family in the late 1980s and early ’90s and experienced first-hand the Gulf War from her home close by the military airbase there.</p><br/>
<p style="text-indent: 00em;">She lives in The West of Ireland with her dog, Rover!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3f78b4a6